// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OER7","colBig":"styles_colBig__H8tWh","colSmall":"styles_colSmall__3-Kf5"};